import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import metaOverrideSet from './metaOverrideSet';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
}));

const DefaultLayout = ({
  collection,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <MetaCollectionFormInline
        collection={collection}
        padding="none"
        metaOverrideSet={metaOverrideSet}
      />
    </div>
  );
};

DefaultLayout.propTypes = {
  collection: PropTypes.object.isRequired,
};

DefaultLayout.defaultProps = {
};

export default DefaultLayout;
